import { AxiosError } from 'axios';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';

import axios from './axios';

export interface UseAcceptPendingUserVariables {
  email: string;
  first_name: string;
  id: number;
  is_admin: boolean;
  is_licensed: boolean;
  last_name: string;
}

export interface UseAcceptPendingUserData {}

export function useAcceptPendingUser() {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation<
    UseAcceptPendingUserData,
    AxiosError<UseAcceptPendingUserData>,
    UseAcceptPendingUserVariables
  >(
    (variables) => {
      const data = { ...variables, is_active: true, send_email: true };

      return axios
        .put<UseAcceptPendingUserData>(
          `/posht/ashena/users/${variables.id}/`,
          data,
        )
        .then((res) => res.data);
    },
    {
      onError: () => {
        enqueueSnackbar(t('errors.unknown'), { variant: 'error' });
      },
      onSuccess: () => {
        enqueueSnackbar(t('operation.successful'), { variant: 'success' });
      },
    },
  );
}
